import { render } from "./Sugerencias.vue?vue&type=template&id=46cf72f8"
import script from "./Sugerencias.vue?vue&type=script&lang=js"
export * from "./Sugerencias.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__